<template>
  <div id="instituteInfo" class="index" v-cloak>
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
<!--    <div class="carousel is_carousel">-->
<!--      <el-carousel :loop="false" :autoplay="false">-->
<!--        <el-carousel-item v-for="(item, index) in instituteList" :key="index">-->
<!--          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>-->
<!--            <div class="content-width">-->
<!--              <div :class="['cs_word', index === 0 ? 'cs_word_white' : '']">-->
<!--                <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>-->
<!--                <div v-cloak class="title2">{{item.title2}}</div>-->
<!--                <div v-cloak class="remark">{{item.remark}}</div>-->
<!--              </div>-->
<!--              <el-button type="primary" round class="use_btn" @click="useClick">申请试用</el-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->

    <!-- 公告/新闻 详情 -->
    <div class="instituteInfo">
      <div class="content">
<!--        <div v-if="articleType == 1" class="location">当前位置：<a href="institute.html">智慧农业</a> >-->
<!--          <a href="institute.html#ist3">更新公告</a> > {{detail.title}}-->
<!--        </div>-->
        <div v-if="articleType == 2" class="location">当前位置：<router-link to="/">智慧农业</router-link> >
          <router-link to="/aboutInfo">智慧资讯</router-link> > {{detail.title}}
        </div>
        <div class="article">
          <div class="a_l">
            <div class="a_l_title">{{detail.title || '--'}}</div>
            <div class="a_l_remark">
              <span>发布时间：{{detail.publishTime}}</span>
              <span>来源：{{detail.source}}</span>
              <span>采编：{{detail.editing}}</span>
              <span>阅读：{{detail.pageviews}}</span>
            </div>
            <div id="dt_ct" class="a_l_content">
              <!-- {{ htmlEncode(detail.content)}} -->
              <div v-html="detail.content"></div>
            </div>
            <div class="a_l_share">
              <div class="share_l">分享到：</div>
              <ul class="share_r">
                <li class="li" @click="share_wx()"><img class="push_icon"
                    src="@/assets/img/index/icon/information_1weixin.svg" /></li>
                <li class="li" @click="share_wx()"><img class="push_icon"
                    src="@/assets/img/index/icon/information_2pengyouquan.svg" /></li>
                <li class="li" @click="share('qzone', detail.title)"><img class="push_icon"
                    src="@/assets/img/index/icon/information_3QQkongjian.svg" /></li>
                <li class="li" @click="share('sina', detail.title)"><img class="push_icon"
                    src="@/assets/img/index/icon/information_4weibo.svg" /></li>

              </ul>
            </div>
          </div>
          <div class="a_r">
            <el-tabs v-model="activeNameInfo">
              <el-tab-pane label="最新资讯" name="first">
                <div class="newsList">
                  <div class="n_li" v-for="(item, index) in newsLists" :key="index" @click="getInfo(2, item.id)">
                    <img class="ns_l" :src="item.picture || '@/assets/img/institute/pic/is3.jpg'" />
                    <div class="ns_r">
                      <div class="ns_r_title ellipsis">{{ item.title }}</div>
                      <div class="ns_r_remark">
                        <span>发布时间：{{ item.publishTime }}</span>
                        <span>阅读：{{item.pageviews}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="相关文章" name="second">
                <span style="font-size: 0.7rem;color: #9D9D9D;">暂无数据</span>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- 客服 -->
    <CustCare />
    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />

  </div>

<!--  <div class="bdsharebuttonbox" style="display:none;">-->
<!--    <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
<!--    <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
<!--  </div>-->
</template>
<script>
  import axios from 'axios'
  import Header from '@/views/pc/components/header'
  import Contact from '@/views/pc/components/contact'
  import CustCare from '@/views/pc/components/custCare'
  import Footer from '@/views/pc/components/footer'
  import Apply from '@/views/pc/components/apply'
  import ApplyIndex from '@/views/pc/components/applyIndex'
  import { formatDate } from '@/utils/dateFormat'
  export default {
    name: "InstituteInfo",
    components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
    // props: {
    //   // 接收父参数
    //   type: {
    //     type: Number,
    //     default: 1
    //   },
    //   id: {
    //     type: Number,
    //     default: 1
    //   }
    // },
    data () {
      return {
        id: 1,
        type: 0,
        // 研究院轮播图
        instituteList: [
          {
            title1: '智慧农业学院',
            title2: '赋能生鲜企业管理',
            remark: '帮助生鲜企业通过精益化管理降本增效',
            url: require('@/assets/img/institute/pic/institute.jpg')
          }
        ],
        articleType: '',
        detail: '',
        baseUrl: this.$baseUrl,
        // 公告新闻消息 tab状态
        activeNameInfo: 'first',
        // 最新资讯列表
        newsLists: [],
      }
    },
    created () {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.getDetail();
      this.getNewsList()
    },
    watch: {
      '$route' () {
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.getDetail();
      }
    },
    methods: {
      // 新闻/公告详情
      getDetail () {
        const that = this
        this.articleType = this.type
        let _detail = that.detail
        const url = that.baseUrl + "/message/geiByIdAndTypeInfo"
        axios.get(url, { params: { id: this.id } }).then(res=>{
          _detail = res.data.data
          if (_detail) {
            _detail.publishTime = formatDate(_detail.publishTime)
            that.detail = _detail
          }
        })
      },
      // 新闻公告详情跳转
      getInfo(type, id){
        console.log('type:', type)
        console.log('id:', id)
        this.$router.push({name:'InstituteInfo', query:{type:type, id:id}});
      },
      // 新闻列表 type 1公告 ，2新闻
      getNewsList () {
        let that = this
        let _data = {
          pageNum: 1,
          pageSize: 8,
          type: 2,
          systemType: 1,
        }
        let newsLists = that.newsLists
        // $.ajax({
        //   url: that.submitUrl + "/message/news/list",
        //   type: "GET",
        //   contentType: 'application/json',
        //   data: _data,
        //   // async : "true",
        //   success: function (res) {
        //     let list = JSON.parse(res)
        //     if (list.newsMap) {
        //       newsLists = list.newsMap.rows
        //     }
        //     that.newsLists = newsLists
        //   }
        // })
        let url = that.baseUrl + "/message/news/list"
        axios.get(url, { params: _data }).then(res=>{
          console.log('res:', res)
          if (res.data.newsMap && res.data.newsMap.rows) {
            newsLists = res.data.newsMap.rows
            that.newsLists = newsLists.map( (e) => {
              e.publishTime = formatDate(e.publishTime)
              return e
            })
          }
        })
      },
      // 试用
      useClick () {
        this.$refs.applyRef.useClick();
      },
      //分享到微信朋友圈
      share_wx(){
        var el = document.getElementById('wx_share');
        el.target = '_new';
        el.click();
      },
      share (pType) {
        var pUrl = window.location.href; //当前的url地址
        this.shareys(pType, pUrl);
      },
      //以下shareys是主要的分享的api接口
      shareys (type, url) {
        const title = '智慧农业Erp官网'
        switch (type) {
          case "sina":
            url = "http://service.weibo.com/share/share.php?title=" + encodeURIComponent('「' + title + '」' + ' 点这里' + url);
            window.open(url);
            break;
          case "tqq":
            url = "http://share.v.t.qq.com/index.php?c=share&a=index&url=" + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
            window.open(url);
            break;
          case "qzone":
            url = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
            window.open(url);
            break;
          default:
            break;
        }
      }
    }
  }
</script>
<!--  <script>-->
<!--    let pUrl = window.location.href;-->
<!--    window._bd_share_config = { "common": { "bdSnsKey": {}, "bdText": "", "bdMini": "", "bdMiniList": false, "bdUrl": pUrl, "bdPic": "", "bdStyle": "", "bdSize": "" }, "share": {} };-->
<!--    with (document) 0[(getElementsByTagName('head')[0] || body).appendChild(createElement('script')).src = 'http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + ~(-new Date() / 36e5)];-->
<!--  </script>-->

<!--  <script src="js/instituteInfo.js"></script>-->
<!--  <script>-->
<!--    let availWidth = document.documentElement.clientWidth-->
<!--    if (availWidth < 1023) {-->
<!--      this.changeUrl()-->
<!--    }-->
<!--    window.addEventListener("resize", function () {-->
<!--      let cwAPP = document.documentElement.clientWidth-->
<!--      if (cwAPP < 1023) {-->
<!--        this.changeUrl()-->
<!--      }-->
<!--    })-->
<!--    function changeUrl () {-->
<!--      let url = 'appinstitute.html'-->
<!--      let a = document.createElement('a');-->
<!--      a.setAttribute('href', url);-->
<!--      a.setAttribute('target', '_self');-->
<!--      a.click();-->
<!--    }-->
<!--  </script>-->
<style lang="scss">
@import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
@import '@/styles/pc/instituteInfo/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/pc/instituteInfo.vue